import { Notyf } from 'notyf';
import 'notyf/notyf.min.css';

export const notyf = new Notyf({
  duration: 2000,
  position: {
    x: 'right',
    y: 'bottom',
  },
  dismissible: false,
  types: [
    {
      type: 'success',
      className: 'retro-notyf retro-notyf-success',
      background: '#2ecc71',
    },
    {
      type: 'error',
      className: 'retro-notyf retro-notyf-error',
      background: '#e74c3c',
    },
  ],
});

const styleTag = document.createElement('style');
styleTag.innerHTML = `
  .retro-notyf {
    font-family: 'JetBrains Mono', monospace;
    border: 2px solid #333;
    box-shadow: 6px 6px 0 #222;
    border-radius: 8px;
    padding: 10px 18px;
    color: white;
    font-weight: bold;
    font-size: 1.5rem;
    text-align: center;
    max-width: 280px;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .retro-notyf-success {
    background-color: #3dc763 !important;
  }

  .retro-notyf-error {
    background-color: #ed3d3d !important;
  }
`;

document.head.appendChild(styleTag);
